import React, { useCallback, useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { v1 as uuidv1 } from 'uuid';
import { gql } from '@yi/core';

import { nr } from '~/common';
import {
  OnMinuteConsumedCbParams,
  useMinuteConsumed,
} from '~/src/components/MediaPlayer/media-lifecycle-hooks';

const { SERIES } = gql.typesClient.LogConsumptionTrackingType;

interface Props {
  episodeId: string;
}

export const LogConsumption: React.FC<Props> = ({ episodeId }) => {
  const [rowId, setRowId] = useState<string | null>(null);
  useEffect(() => {
    setRowId(uuidv1());
  }, [episodeId]);

  const [logConsumptionTracking] = useMutation<
    gql.typesClient.Mutate_LogConsumptionTracking,
    gql.typesClient.Mutate_LogConsumptionTrackingVariables
  >(gql.Mutate_LogConsumptionTracking, {
    onError: error => nr.noticeError(error),
  });

  const minuteConsumedHandler = useCallback(
    ({ mediaDurationMinutes, totalMinutesConsumed }: OnMinuteConsumedCbParams) => {
      if (!rowId) return;

      logConsumptionTracking({
        variables: {
          row_id: rowId,
          class_id: episodeId,
          minutes: totalMinutesConsumed,
          duration: mediaDurationMinutes,
          type: SERIES,
          // @TODO ?
          // searchInsightsIndexName: indexName,
          // searchInsightsQueryID: queryID,
          // contentTitle: title || '',
          // contentAuthor: teacherFullName,
          // contentTag: contentTag || '',
        },
      });
    },
    [rowId, episodeId, logConsumptionTracking],
  );

  useMinuteConsumed(minuteConsumedHandler);

  return null;
};
